import React, { useState } from 'react';

/*
 * SignupSection renders the call‑to‑action area where interested users can
 * join a waitlist.  It features a simple form with required fields
 * indicated by an asterisk.  Basic client‑side validation prevents
 * submission when required fields are missing.  Integration with
 * FastAPI can be added later in the handleSubmit function.
 */
function SignupSection() {
  const [formData, setFormData] = useState({
    nome: '',
    cognome: '',
    azienda: '',
    ruolo: '',
    telefono: '',
    email: '',
    note: '',
    privacy: false,
    conoscenza: ""
  });
  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;;
    setFormData((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  // Returns an object of missing required fields
  const validate = () => {
    const newErrors = {};
    if (!formData.nome.trim()) newErrors.nome = 'Campo obbligatorio';
    else if (formData.nome.length > 15) newErrors.nome = 'Massimo 15 caratteri';

    if (!formData.cognome.trim()) newErrors.cognome = 'Campo obbligatorio';
    else if (formData.cognome.length > 20) newErrors.cognome = 'Massimo 20 caratteri';

    if (!formData.azienda.trim()) newErrors.azienda = 'Campo obbligatorio';
    else if (formData.azienda.length > 20) newErrors.azienda = 'Massimo 20 caratteri';

    if (!formData.ruolo.trim()) newErrors.ruolo = 'Campo obbligatorio';
    else if (formData.ruolo.length > 20) newErrors.ruolo = 'Massimo 20 caratteri'

    if (formData.telefono && formData.telefono.length > 20) newErrors.telefono = 'Massimo 20 caratteri';

    if (!formData.email.trim()) newErrors.email = 'Campo obbligatorio';
    else if (!/\S+@\S+\.\S+/.test(formData.email)) newErrors.email = 'Email non valida';
    else if (formData.email.length > 50) newErrors.email = 'Massimo 50 caratteri'

    if (formData.note && formData.note.length > 500) newErrors.note = 'Massimo 500 caratteri';

    if (!formData.conoscenza.trim()) newErrors.conoscenza = 'Campo obbligatorio';
    else if (!formData.conoscenza) {errors.conoscenza = "Seleziona un'opzione";}

    if (!formData.privacy) newErrors.privacy = 'Devi accettare l’informativa';
    return newErrors;
  };



  const handleSubmit = (e) => {
    e.preventDefault();
    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);

      // reset casella privacy ogni errore
      setFormData((prev) => ({
        ...prev,
        privacy: false
      }));
      // fine reset casella privacy

      return;
    }

    // All required fields filled
    setErrors({});

    // ——— Send to backend ———
    fetch('https://wg-landingpage-backend.onrender.com/submit', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(formData)
    })
      .then((res) => {
        if (res.status === 201) {
          alert('Grazie per la tua registrazione!');
          // Reset form on success
          setFormData({
            nome: '',
            cognome: '',
            azienda: '',
            ruolo: '',
            telefono: '',
            email: '',
            note: '',
            privacy: false,
            conoscenza: ''
          });
        }


       else if (res.status === 409) {
        // 409 Conflict: email già registrata
            res.text().then((text) => {
            setErrors({ email: text });
          });
        }




        else {
          alert('Si è verificato un errore sul server. Riprova più tardi.');
        }
      })
      .catch((err) => {
        console.error('Submit error:', err);
        alert('Impossibile raggiungere il server. Controlla la connessione.');
      });
  };

  

  return (
    <section className="signup-section">
      <div className="signup-container">
        <h2>
          <span className="color-wisy">wisy</span>
            <span className="color-guide">guide</span>
             <span className="color-boldtext"> è pronto per rivoluzionare il tuo customer service.</span>
        </h2>
        <p>
          Vuoi essere tra i primi a provarlo? Inserisci i tuoi dati qui sotto ed
          iscriviti alla waitlist per accedere in anteprima:
        </p>
        <form onSubmit={handleSubmit} noValidate>

        {/* NOME */}  
        <div className="form-group">
        {errors.nome && (
          <div className="error-message">{errors.nome}</div>
        )}
          <input
            type="text"
            name="nome"
            placeholder="Nome*"
            value={formData.nome}
            onChange={handleChange}
          />
        </div>

        {/* COGNOME */}
        <div className="form-group">
        {errors.cognome && (
          <div className="error-message">{errors.cognome}</div>
        )}
        <input
          type="text"
          name="cognome"
          placeholder="Cognome*"
          value={formData.cognome}
          onChange={handleChange}
        />
      </div>


        {/* AZIENDA */}
        <div className="form-group">
          {errors.azienda && (
            <div className="error-message">{errors.azienda}</div>
          )}
          <input
            type="text"
            name="azienda"
            placeholder="Azienda*"
            value={formData.azienda}
            onChange={handleChange}
          />
        </div>



        {/* RUOLO */}
        <div className="form-group">
        {errors.ruolo && (
          <div className="error-message">{errors.ruolo}</div>
        )}
        <input
          type="text"
          name="ruolo"
          placeholder="Ruolo aziendale*"
          value={formData.ruolo}
          onChange={handleChange}
        />
      </div>



        {/* TELEFONO (optional) */}
        <input
          type="tel"
          name="telefono"
          placeholder="Telefono"
          value={formData.telefono}
          onChange={handleChange}
        />


        {/* EMAIL */}
        <div className="form-group">
          {errors.email && (
            <div className="error-message">{errors.email}</div>
          )}
          <input
            type="email"
            name="email"
            placeholder="Email*"
            value={formData.email}
            onChange={handleChange}
          />
        </div>

        {/* conoscenza*/}
        {errors.conoscenza && (
        <div className="error-message">{errors.conoscenza}</div>
        )}
        <div className="form-group">
        <select
          name="conoscenza"
          value={formData.conoscenza}
          onChange={handleChange}
          required
        >
          <option value="" disabled>
          Come ci hai conosciuti?
          </option>

          <option value="LinkedIn">LinkedIn</option>
          <option value="Instagram">Instagram</option>
          <option value="Altro">Altro</option>
          </select>
        </div>

        {/* NOTE (optional) */}
        {errors.note && (
        <div className="error-message">{errors.note}</div>
        )}

        <textarea
          name="note"
          placeholder="Hai domande o richieste particolari?"
          value={formData.note}
          onChange={handleChange}
        />


        {/* ——— Privacy checkbox — mandatory ——— */}
  <div className="privacy-container">
    <input
      type="checkbox"
      id="privacy"
      name="privacy"
      checked={formData.privacy}
      onChange={handleChange}
    />
    <label htmlFor="privacy">
      Dichiaro di aver letto e compreso l’
      <a href="/privacy-policy.html" target="_blank" rel="noopener">
        Informativa sulla Privacy
      </a>
      {' '}e acconsento al trattamento dei miei dati personali ai sensi del Regolamento UE 2016/679 (GDPR).
    </label>
  </div>
  {errors.privacy && (
    <div className="error-message">{errors.privacy}</div>
  )}



        <button type="submit">Iscriviti</button>
        </form>
      </div>
    </section>
  );
}

export default SignupSection;
